import { Team } from '@bringg/types';

import { useHasFeatureFlag } from './feature-flags';

export const ENABLE_CUSTOMER_WP_TIMEZONES = 'enable_customer_wp_timezones';

export const useWayPointTimeZoneEnabled = (team?: Team) => {
	return useHasFeatureFlag(ENABLE_CUSTOMER_WP_TIMEZONES, team);
};
